//====================================================
//  Function: Slider
//====================================================
function fn_components_slider(){
	fn_partners_slider();
	fn_partners_detail_slider();
	fn_history_slider();
	fn_gallery_slider();
	fn_hero_slider();
	fn_recycle_slider();
}

function fn_partners_detail_slider(){
	if ($( '.js-slider-partners-detail' ).length) {
		$( '.js-slider-partners-detail' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1220,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 540,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 200,
					settings: {
						slidesToShow: 2,
					}
				}
			]
		});
	}
}

function fn_partners_slider(){
	if ($( '.js-slider-partners' ).length) {
		$( '.js-slider-partners' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1220,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 540,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 200,
					settings: {
						slidesToShow: 2,
					}
				}
			]
		});
	}
}


function fn_history_slider(){
	if ($( '.js-slider-history' ).length) {
		$( '.js-slider-history' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			asNavFor: '.js-slider-history-image',
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon-hexagon"><i class="icon icon-text icon-arrow-right"></i></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon-hexagon"><i class="icon icon-text icon-arrow-right"></i></i></span>',
			mobileFirst: true
		});
	}

	if ($( '.js-slider-history-image' ).length) {
		$( '.js-slider-history-image' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			asNavFor: '.js-slider-history',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon-hexagon"><i class="icon icon-text icon-arrow-right"></i></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon-hexagon"><i class="icon icon-text icon-arrow-right"></i></i></span>',
			mobileFirst: true
		});
	}
}

function fn_recycle_slider(){
	if ($( '.js-slider-recycle' ).length) {
		$( '.js-slider-recycle' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			cssEase: 'linear',
			speed: 300,
			fade: true,
			variableWidth: false,
			mobileFirst: true
		});
		
		$( '.js-slider-recycle' ).on( 'afterChange' , function(event, slick, currentSlide, nextSlide){
			var thisId = currentSlide + 1;

			$( '.js-process-item' ).removeClass( class_active );

			$( '.js-process-item' ).each(function(index){
				if (index <  thisId){
					$(this).addClass( class_active );
				}
			});

			rotateProcessIcons(thisId);
		});
	}


	if ($( '.js-process-item' ).length){
		$( '.js-process-item' ).on( 'click' , function () {
			var inst = $( this );
			var thisId = inst.data( 'id' );

			$( '.js-process-item' ).removeClass( class_active );

			$( '.js-process-item' ).each(function(index){
				if (index <  thisId){
					$(this).addClass( class_active );
				}
			});

			$( '.js-slider-recycle' ).slick('slickGoTo', thisId - 1);

			rotateProcessIcons(thisId);
		});
	}
}

function rotateProcessIcons(id){
	var degree, position;
	$( '#recycle-process-icons .recycle-process-item' ).removeClass( 'opacity-0' );
	$( '#recycle-process-icons .recycle-arrow' ).removeClass( 'opacity-0' );
	switch (id) {
	    case 1:
			degree = 0;
			position = 1;
			$( '#recycle-process-icons .recycle-process-item-4' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-process-item-5' ).addClass( 'opacity-0' );
			
			$( '#recycle-process-icons .recycle-arrow-3' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-4' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-5' ).addClass( 'opacity-0' );
	        break;
	    case 2:
			degree = -72;
			position = 3;
			$( '#recycle-process-icons .recycle-process-item-2' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-process-item-4' ).addClass( 'opacity-0' );
	       
	        $( '#recycle-process-icons .recycle-arrow-1' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-3' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-5' ).addClass( 'opacity-0' );
	        break;
	    case 3:
			degree = -144;
			position = 5;
			$( '#recycle-process-icons .recycle-process-item-1' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-process-item-2' ).addClass( 'opacity-0' );
	        
	        $( '#recycle-process-icons .recycle-arrow-1' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-2' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-3' ).addClass( 'opacity-0' );
	        break;
	    case 4:
			degree = -216;
			position = 4;
			$( '#recycle-process-icons .recycle-process-item-1' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-process-item-3' ).addClass( 'opacity-0' );
	        
	        $( '#recycle-process-icons .recycle-arrow-1' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-2' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-4' ).addClass( 'opacity-0' );
	        break;
	    case 5:
			degree = -288;
			position = 2;
			$( '#recycle-process-icons .recycle-process-item-5' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-process-item-3' ).addClass( 'opacity-0' );
	        
	        $( '#recycle-process-icons .recycle-arrow-4' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-2' ).addClass( 'opacity-0' );
			$( '#recycle-process-icons .recycle-arrow-5' ).addClass( 'opacity-0' );
	        break;
	  //   case 5:
			// degree = 360;
	  //       break;
	}

	if ($(window).width() < 360){
		$( '#recycle-process-icons' ).css( 'transform', 'rotateZ(' + degree +'deg) scale(0.80)' );
		$( '#recycle-process-icons .recycle-process-circle img' ).css( 'transform', 'rotateZ(-' + degree +'deg)' );
	} else {
		$( '#recycle-process-icons' ).css( 'transform', 'rotateZ(' + degree +'deg)' );
		$( '#recycle-process-icons .recycle-process-circle img' ).css( 'transform', 'rotateZ(' + -(degree) +'deg)' );
	}


	$( '#recycle-process-icons .recycle-process-item' ).removeClass( class_active );
	$( '#recycle-process-icons .recycle-process-item-' + position + '' ).addClass( class_active );

}

function fn_gallery_slider(){
	if ($( '.js-slider-gallery-main' ).length) {
		$( '.js-slider-gallery-main' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			autoplaySpeed: 2000,
			cssEase: 'linear',
			speed: 500,
			fade: true,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			variableWidth: false,
			mobileFirst: true,
			asNavFor:  '.js-slider-gallery-thumbnail' 
		});
	}

	if ($( '.js-slider-gallery-thumbnail' ).length) {
		$( '.js-slider-gallery-thumbnail' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 8,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 2000,
			variableWidth: true,
			cssEase: 'linear',
			speed: 500,
			centerMode : false,
			asNavFor: '.js-slider-gallery-main' ,
			focusOnSelect: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1220,
					settings: {
						variableWidth: true,
						slidesToShow: 8,
					}
				},
				{
					breakpoint: 992,
					settings: {
						variableWidth: false,
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 768,
					settings: {
						variableWidth: false,
						slidesToShow: 6,
					}
				},
				{
					breakpoint: 540,
					settings: {
						variableWidth: false,
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 200,
					settings: {
						variableWidth: false,
						slidesToShow: 2,
					}
				}
			]
		});
	}
}


function fn_hero_slider(){
	if ($( '.js-slider-hero-image' ).length) {
		$( '.js-slider-hero-image' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			fade: true,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			variableWidth: false,
			mobileFirst: true,
			asNavFor:  '.js-slider-hero-text' 
		});
	}

	if ($( '.js-slider-hero-text' ).length) {
		$( '.js-slider-hero-text' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 2000,
			variableWidth: false,
			cssEase: 'linear',
			speed: 500,
			centerMode : false,
			asNavFor: '.js-slider-hero-image' ,
			focusOnSelect: true,
			mobileFirst: true,
		});
	}
}
